import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from "axios"
import Vuelidate from 'vuelidate'
import storeB from '@/store/breadcrumb.js'
//import routes from './router/index.js'
//import routes from './router/route.js'
import Vuex from 'vuex'
import store from './store'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import ymapPlugin from 'vue-yandex-maps';
import VueAwesomeSwiper from 'vue-awesome-swiper'

import Meta from 'vue-meta'
Vue.use(Meta)
// require styles
import 'swiper/css/swiper.css'

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(Vuex)
let mnuCafePath, mnuEntertatmentPath, mnuServicePath, mnuShopsPath, mnuGalleryPath, mnuNewsPath, mnuAboutPath, mnuArendaPath, mnuContactsPath

Vue.use(
  Vuelidate,
  Vuex,
  ymapPlugin,
  VueAwesomeSwiper,

)

 console.log('main JS');

/* screen.addEventListener("orientationchange", function () {
  if(DEBUG) console.log("############## <<<<< The orientation of the screen is: " + screen.orientation);
  }) */

/* let thprval = routes.then(function (val) {
  if(DEBUG) console.log('main JS wait',val);

new Vue({
  router: val,
  store,
  vuetify,
  
  render: h => h(App)
}).$mount('#app')

});

if(DEBUG) console.log('main JS thprval',thprval); */


axios({
    method: "get",
    url: "http://api.trcgagarinsky.ru/terminal__tmp/index.php/js/get_site_menu/"

  })
  .catch(function (error) {
    // handle error
    if(DEBUG) console.log("ERROR: ", error);
  })
  .then(function (response) {
    // handle success
    if(DEBUG) console.log(" response dataMenu =", response.data.menu);
    mnuCafePath = response.data.menu.find(jf => jf.id === '3').url;
    mnuShopsPath = response.data.menu.find(jf => jf.id === '1').url;
    mnuEntertatmentPath = response.data.menu.find(jf => jf.id === '5').url;
    mnuServicePath = response.data.menu.find(jf => jf.id === '6').url;
    mnuNewsPath = response.data.menu.find(jf => jf.id === '7').url;
    mnuAboutPath = response.data.menu.find(jf => jf.id === '8').url;
    mnuGalleryPath = response.data.menu.find(jf => jf.id === '9').url;
    mnuArendaPath = response.data.menu.find(jf => jf.id === '10').url;
    mnuContactsPath = response.data.menu.find(jf => jf.id === '11').url;


    const routes = [
      {
        path: "/",
        name: "Home",
        component: () => import("@/components/Home")
      },
      {
        path: "/page/:namePage",
        name: "SinglePage",
        component: () => import("@/components/SinglePage")
      },
      {
        path: '/' + mnuNewsPath + '/:idNews',
        name: 'SingleNews',
        component: () => import("@/components/SingleNews")
      },
      {
        path: '/' + mnuShopsPath + '/:idShop',
        name: 'SingleShop',
        component: () => import("@/components/SingleShop")
      },
      {
        path: '/' + mnuCafePath + '/:idShop',
        name: 'SingleCafe',
        component: () => import("@/components/SingleShop")
      },
      {
        path: '/' + mnuServicePath + '/:idShop',
        name: 'SingleService',
        component: () => import("@/components/SingleShop")
      },
      {
        path: '/' + mnuEntertatmentPath + '/:idShop',
        name: 'SingleEntertaintment',
        component: () => import("@/components/SingleShop")
      },
      {
        path: '/' + mnuShopsPath,
        name: 'AllShops',
        component: () => import("@/components/AllShops"),
        props:{selectTab:0}
      },
      {
        path: '/' + mnuServicePath + '/category/:nameCategory',
        name: 'AllServicesCategory',
        component: () => import("@/components/AllServicesCategory"),
        props:{selectTab:0}
      },
      {
        path: '/' + mnuShopsPath + '/category/:nameCategory',
        name: 'AllShopsCategory',
        component: () => import("@/components/AllShopsCategory"),
        props:{selectTab:0}
      },
      {
        path: '/' + mnuCafePath,
        name: 'AllCafe',
        component: () => import("@/components/AllCafe")
      },
      {
        path: '/' + mnuEntertatmentPath,
        name: 'Entertaintment',
        component: () => import("@/components/Entertaintment")
      },
      {
        path: '/' + mnuServicePath,
        name: 'AllServices',
        component: () => import("@/components/AllServices")
      },
      {
        path: '/' + mnuNewsPath,
        name: 'AllNews',
        component: () => import("@/components/AllNews")
      },
      {
        path: '/' + mnuAboutPath,
        name: 'AboutTRC',
        component: () => import("@/components/AboutTRC")
      },
      {
        path: '/' + mnuContactsPath,
        name: 'Contacts',
        component: () => import("@/components/Contacts")
      },
      {
        path: '/' + mnuArendaPath,
        name: 'Arenda',
        component: () => import("@/components/Arenda")
      },
      {
        path: '/' + mnuGalleryPath,
        name: 'Gallery',
        component: () => import("@/components/Gallery")
      },
      {
        path: '/' + mnuGalleryPath + '/:idGallery',
        name: 'SingleGallery',
        component: () => import("@/components/SingleGallery")
      },
      {
        path: "*",
        name: "Error404Page",
        component: () => import("@/components/404")
      }
    ];

    if(DEBUG) console.log(" *****************ROUTES JS INn =", routes);


    const router = new VueRouter({
      //base: '/newgagarin/',
      base: '/',
      mode: 'history',
      //  base: process.env.BASE_URL,
      routes,
      scrollBehavior(to, from, savedPosition) {
        return {
          x: 0,
          y: 0
        }
      }
    });

    router.beforeEach((to, from, next) => {
      if(DEBUG) console.log('beforeEach to :', to);
      if(DEBUG) console.log('beforeEach from :', from);
      if(DEBUG) console.log('store :', storeB);
      const itemP = to.name
      let arrCurrPath = to.fullPath.split("/");
      if(DEBUG) console.log('arrCurrPath :>> ', arrCurrPath);

      let nodeBrd = {
        text: "",
        disabled: true,
        href: "",
      };

      let arrBr = [{
        text: "Главная",
        disabled: true,
        href: "/",
      }]


      switch (itemP) {
        case "Home":
          nodeBrd.text = "Главная";
          nodeBrd.disabled = false;
          nodeBrd.href = "/";
          break;
        case "AllShops":

          if(DEBUG) console.log("itemP :>> ", itemP);

          /*       nodeBrd.text = "Магазины";
                nodeBrd.disabled = false;
                nodeBrd.href = ""; */
          arrBr.push({
            text: "Магазины",
            disabled: false,
            href: "",
          })
          break;
        case "AllShopsCategory":

          if(DEBUG) console.log("itemP :>> ", itemP);

          /*       nodeBrd.text = "Магазины";
                nodeBrd.disabled = false;
                nodeBrd.href = ""; */
          arrBr.push({
            text: "Магазины",
            disabled: false,
            href: "",
          })
          break;
        case "AllServicesCategory":

          if(DEBUG) console.log("itemP :>> ", itemP);

          /*       nodeBrd.text = "Магазины";
                nodeBrd.disabled = false;
                nodeBrd.href = ""; */
          arrBr.push({
            text: "Услуги",
            disabled: false,
            href: "",
          })
          break;


        case "AllCafe":
          /*       nodeBrd.text = "Рестораны и Кафе";
                nodeBrd.disabled = false;
                nodeBrd.href = ""; */
          arrBr.push({
            text: "Рестораны и Кафе",
            disabled: false,
            href: "",
          })


          break;
        case "AllNews":
          //  nameIdNews = vApp.allNews.find((fShp) => fShp.slug === itemP);
          /*       nodeBrd.text = "Новости";
                nodeBrd.disabled = false;
                nodeBrd.href = ""; */
          arrBr.push({
            text: "Новости",
            disabled: false,
            href: "",
          })


          break;
        case "Entertaintment":
          /*       nodeBrd.text = "Развлечения";
                nodeBrd.disabled = false;
                nodeBrd.href = ""; */
          arrBr.push({
            text: "Развлечения",
            disabled: false,
            href: "",
          })


          break;
        case "AllServices":
          /*       nodeBrd.text = "Услуги";
                nodeBrd.disabled = false;
                nodeBrd.href = ""; */

          arrBr.push({
            text: "Услуги",
            disabled: false,
            href: "",
          })

          break;
        case "AboutTRC":
          /*       nodeBrd.text = "О ТРЦ";
                nodeBrd.disabled = false;
                nodeBrd.href = ""; */
          arrBr.push({
            text: "О ТРЦ",
            disabled: false,
            href: "",
          })


          break;
        case "Gallery":
          /*       nodeBrd.text = "Фотогалерея";
                nodeBrd.disabled = false;
                nodeBrd.href = ""; */
          arrBr.push({
            text: "Фотогалерея",
            disabled: false,
            href: "",
          })

          break;

        case "Arenda":
          /*       nodeBrd.text = "Заявка  на аренду";
                nodeBrd.disabled = true;
                nodeBrd.href = ""; */

          arrBr.push({
            text: "Заявка  на аренду",
            disabled: false,
            href: "",
          })

          break;
        case "Contacts":
          nodeBrd.text = "Контакты";
          nodeBrd.disabled = true;
          nodeBrd.href = "";
          arrBr.push({
            text: "Контакты",
            disabled: false,
            href: "",
          })

          break;
        case "SinglePage":
          nodeBrd.text = "Страница";
          nodeBrd.disabled = true;
          nodeBrd.href = "";
          arrBr.push({
            text: "Страница",
            disabled: false,
            href: "",
          })

          break;


        case "SingleShop":
          /*       nodeBrd.text = "Магазин";
                nodeBrd.disabled = true;
                nodeBrd.href = ""; */
          if(DEBUG) console.log('to.path.split(/)[0] :>> ', arrCurrPath[1]);

          arrBr.push({
            text: "Магазины",
            disabled: true,
            href: "/" + arrCurrPath[1]
          }, {
            text: "",
            disabled: false,
            href: "",
          })

          break;
        case "SingleCafe":
          /*       nodeBrd.text = "Кафе и рестораны";
                nodeBrd.disabled = true;
                nodeBrd.href = ""; */

          arrBr.push({
            text: "Кафе и рестораны",
            disabled: true,
            href: "/" + arrCurrPath[1]
          }, {
            text: "",
            disabled: false,
            href: "",
          })

          break;
        case "SingleEntertaintment":
          /*       nodeBrd.text = "Кафе и рестораны";
                nodeBrd.disabled = true;
                nodeBrd.href = ""; */

          arrBr.push({
            text: "Развлечения",
            disabled: true,
            href: "/" + arrCurrPath[1]
          }, {
            text: "",
            disabled: false,
            href: "",
          })

          break;
        case "SingleService":
          /*       nodeBrd.text = "Кафе и рестораны";
                nodeBrd.disabled = true;
                nodeBrd.href = ""; */

          arrBr.push({
            text: "Услуги",
            disabled: true,
            href: "/" + arrCurrPath[1]
          }, {
            text: "",
            disabled: false,
            href: "",
          })

          break;
        case "SingleNews":
          /*       nodeBrd.text = "Кафе и рестораны";
                nodeBrd.disabled = true;
                nodeBrd.href = ""; */

          arrBr.push({
            text: "Новости",
            disabled: true,
            href: "/" + arrCurrPath[1]
          }, {
            text: "",
            disabled: false,
            href: "",
          })

          break;
        case "SingleGallery":
          /*       nodeBrd.text = "Кафе и рестораны";
                nodeBrd.disabled = true;
                nodeBrd.href = ""; */

          arrBr.push({
            text: "Фотогаллерея",
            disabled: true,
            href: "/" + arrCurrPath[1]
          }, {
            text: "",
            disabled: false,
            href: "",
          })

          break;

        default:
          let nameIdShop = null;
          let nameIdNews = null;
          nodeBrd.disabled = true;
          nodeBrd.href = "";
          break;
      }
      if(DEBUG) console.log('nodeBrd :>> ', nodeBrd);
      if(DEBUG) console.log('storeB.store :>> ', storeB.state);


      storeB.state.currBreadcrumb = arrBr
      next();
    })


    router.afterEach((to, from, next) => {
/*       if(DEBUG) console.log('afterEach to :', to);
      if(DEBUG) console.log('afterEach from :', from); */


    })


    if(DEBUG) console.log(" %%%%%%%%%%%%%%%%%%%%%%% =========>>>> ROUTER JS INn =", router);

    new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app')



  });
